/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DatasetCreate,
  DatasetItemAdd,
  DatasetItemResponse,
  DatasetResponse,
  DatasetUpdate,
  DeleteDatasetApiDatasetsDatasetIdDelete200,
  HTTPValidationError,
  RemoveItemApiDatasetsDatasetIdItemsTraceIdDelete200,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listDatasetsApiDatasetsGetResponse200 = {
  data: DatasetResponse[];
  status: 200;
};

export type listDatasetsApiDatasetsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listDatasetsApiDatasetsGetResponseSuccess =
  listDatasetsApiDatasetsGetResponse200 & {
    headers: Headers;
  };
export type listDatasetsApiDatasetsGetResponseError =
  listDatasetsApiDatasetsGetResponse422 & {
    headers: Headers;
  };

export type listDatasetsApiDatasetsGetResponse =
  | listDatasetsApiDatasetsGetResponseSuccess
  | listDatasetsApiDatasetsGetResponseError;

export const getListDatasetsApiDatasetsGetUrl = () => {
  return `/api/datasets`;
};

/**
 * List datasets for the team, newest first, with item counts.
 * @summary List Datasets
 */
export const listDatasetsApiDatasetsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listDatasetsApiDatasetsGetResponse> => {
  return orvalFetch<listDatasetsApiDatasetsGetResponse>(
    getListDatasetsApiDatasetsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListDatasetsApiDatasetsGetQueryKey = () => {
  return [`/api/datasets`] as const;
};

export const getListDatasetsApiDatasetsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListDatasetsApiDatasetsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>
  > = ({ signal }) => listDatasetsApiDatasetsGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDatasetsApiDatasetsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>
>;
export type ListDatasetsApiDatasetsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListDatasetsApiDatasetsGet<
  TData = Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
          TError,
          Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDatasetsApiDatasetsGet<
  TData = Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
          TError,
          Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDatasetsApiDatasetsGet<
  TData = Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Datasets
 */

export function useListDatasetsApiDatasetsGet<
  TData = Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDatasetsApiDatasetsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListDatasetsApiDatasetsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createDatasetApiDatasetsPostResponse201 = {
  data: DatasetResponse;
  status: 201;
};

export type createDatasetApiDatasetsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createDatasetApiDatasetsPostResponseSuccess =
  createDatasetApiDatasetsPostResponse201 & {
    headers: Headers;
  };
export type createDatasetApiDatasetsPostResponseError =
  createDatasetApiDatasetsPostResponse422 & {
    headers: Headers;
  };

export type createDatasetApiDatasetsPostResponse =
  | createDatasetApiDatasetsPostResponseSuccess
  | createDatasetApiDatasetsPostResponseError;

export const getCreateDatasetApiDatasetsPostUrl = () => {
  return `/api/datasets`;
};

/**
 * Create an empty dataset.
 * @summary Create Dataset
 */
export const createDatasetApiDatasetsPost = async (
  datasetCreate: DatasetCreate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createDatasetApiDatasetsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createDatasetApiDatasetsPostResponse>(
    getCreateDatasetApiDatasetsPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(datasetCreate),
    },
  );
};

export const getCreateDatasetApiDatasetsPostMutationKey = () =>
  ["createDatasetApiDatasetsPost"] as const;

export const getCreateDatasetApiDatasetsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDatasetApiDatasetsPost>>,
    TError,
    CreateDatasetApiDatasetsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDatasetApiDatasetsPost>>,
  TError,
  CreateDatasetApiDatasetsPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateDatasetApiDatasetsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDatasetApiDatasetsPost>>,
    CreateDatasetApiDatasetsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createDatasetApiDatasetsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDatasetApiDatasetsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDatasetApiDatasetsPost>>
>;
export type CreateDatasetApiDatasetsPostMutationBody = DatasetCreate;
export type CreateDatasetApiDatasetsPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateDatasetApiDatasetsPostMutationVariables = {
  data: DatasetCreate;
};

/**
 * @summary Create Dataset
 */
export const useCreateDatasetApiDatasetsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDatasetApiDatasetsPost>>,
      TError,
      CreateDatasetApiDatasetsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDatasetApiDatasetsPost>>,
  TError,
  CreateDatasetApiDatasetsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateDatasetApiDatasetsPostMutationOptions(options),
    queryClient,
  );
};
export type getDatasetApiDatasetsDatasetIdGetResponse200 = {
  data: DatasetResponse;
  status: 200;
};

export type getDatasetApiDatasetsDatasetIdGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getDatasetApiDatasetsDatasetIdGetResponseSuccess =
  getDatasetApiDatasetsDatasetIdGetResponse200 & {
    headers: Headers;
  };
export type getDatasetApiDatasetsDatasetIdGetResponseError =
  getDatasetApiDatasetsDatasetIdGetResponse422 & {
    headers: Headers;
  };

export type getDatasetApiDatasetsDatasetIdGetResponse =
  | getDatasetApiDatasetsDatasetIdGetResponseSuccess
  | getDatasetApiDatasetsDatasetIdGetResponseError;

export const getGetDatasetApiDatasetsDatasetIdGetUrl = (datasetId: string) => {
  return `/api/datasets/${datasetId}`;
};

/**
 * One dataset; opening it is recorded in the team's audit log (TRA-1626).
 * @summary Get Dataset
 */
export const getDatasetApiDatasetsDatasetIdGet = async (
  datasetId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getDatasetApiDatasetsDatasetIdGetResponse> => {
  return orvalFetch<getDatasetApiDatasetsDatasetIdGetResponse>(
    getGetDatasetApiDatasetsDatasetIdGetUrl(datasetId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDatasetApiDatasetsDatasetIdGetQueryKey = (
  datasetId: string,
) => {
  return [`/api/datasets/${datasetId}`] as const;
};

export const getGetDatasetApiDatasetsDatasetIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDatasetApiDatasetsDatasetIdGetQueryKey(datasetId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>
  > = ({ signal }) =>
    getDatasetApiDatasetsDatasetIdGet(datasetId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: datasetId !== null && datasetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDatasetApiDatasetsDatasetIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>
>;
export type GetDatasetApiDatasetsDatasetIdGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetDatasetApiDatasetsDatasetIdGet<
  TData = Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDatasetApiDatasetsDatasetIdGet<
  TData = Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDatasetApiDatasetsDatasetIdGet<
  TData = Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dataset
 */

export function useGetDatasetApiDatasetsDatasetIdGet<
  TData = Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDatasetApiDatasetsDatasetIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDatasetApiDatasetsDatasetIdGetQueryOptions(
    datasetId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateDatasetApiDatasetsDatasetIdPatchResponse200 = {
  data: DatasetResponse;
  status: 200;
};

export type updateDatasetApiDatasetsDatasetIdPatchResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateDatasetApiDatasetsDatasetIdPatchResponseSuccess =
  updateDatasetApiDatasetsDatasetIdPatchResponse200 & {
    headers: Headers;
  };
export type updateDatasetApiDatasetsDatasetIdPatchResponseError =
  updateDatasetApiDatasetsDatasetIdPatchResponse422 & {
    headers: Headers;
  };

export type updateDatasetApiDatasetsDatasetIdPatchResponse =
  | updateDatasetApiDatasetsDatasetIdPatchResponseSuccess
  | updateDatasetApiDatasetsDatasetIdPatchResponseError;

export const getUpdateDatasetApiDatasetsDatasetIdPatchUrl = (
  datasetId: string,
) => {
  return `/api/datasets/${datasetId}`;
};

/**
 * @summary Update Dataset
 */
export const updateDatasetApiDatasetsDatasetIdPatch = async (
  datasetId: string,
  datasetUpdate: DatasetUpdate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<updateDatasetApiDatasetsDatasetIdPatchResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<updateDatasetApiDatasetsDatasetIdPatchResponse>(
    getUpdateDatasetApiDatasetsDatasetIdPatchUrl(datasetId),
    {
      ...options,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(datasetUpdate),
    },
  );
};

export const getUpdateDatasetApiDatasetsDatasetIdPatchMutationKey = () =>
  ["updateDatasetApiDatasetsDatasetIdPatch"] as const;

export const getUpdateDatasetApiDatasetsDatasetIdPatchMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDatasetApiDatasetsDatasetIdPatch>>,
    TError,
    UpdateDatasetApiDatasetsDatasetIdPatchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDatasetApiDatasetsDatasetIdPatch>>,
  TError,
  UpdateDatasetApiDatasetsDatasetIdPatchMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateDatasetApiDatasetsDatasetIdPatchMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDatasetApiDatasetsDatasetIdPatch>>,
    UpdateDatasetApiDatasetsDatasetIdPatchMutationVariables
  > = (props) => {
    const { datasetId, data } = props ?? {};

    return updateDatasetApiDatasetsDatasetIdPatch(
      datasetId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDatasetApiDatasetsDatasetIdPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDatasetApiDatasetsDatasetIdPatch>>
>;
export type UpdateDatasetApiDatasetsDatasetIdPatchMutationBody = DatasetUpdate;
export type UpdateDatasetApiDatasetsDatasetIdPatchMutationError =
  ErrorType<HTTPValidationError>;
export type UpdateDatasetApiDatasetsDatasetIdPatchMutationVariables = {
  datasetId: string;
  data: DatasetUpdate;
};

/**
 * @summary Update Dataset
 */
export const useUpdateDatasetApiDatasetsDatasetIdPatch = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDatasetApiDatasetsDatasetIdPatch>>,
      TError,
      UpdateDatasetApiDatasetsDatasetIdPatchMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDatasetApiDatasetsDatasetIdPatch>>,
  TError,
  UpdateDatasetApiDatasetsDatasetIdPatchMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateDatasetApiDatasetsDatasetIdPatchMutationOptions(options),
    queryClient,
  );
};
export type deleteDatasetApiDatasetsDatasetIdDeleteResponse200 = {
  data: DeleteDatasetApiDatasetsDatasetIdDelete200;
  status: 200;
};

export type deleteDatasetApiDatasetsDatasetIdDeleteResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteDatasetApiDatasetsDatasetIdDeleteResponseSuccess =
  deleteDatasetApiDatasetsDatasetIdDeleteResponse200 & {
    headers: Headers;
  };
export type deleteDatasetApiDatasetsDatasetIdDeleteResponseError =
  deleteDatasetApiDatasetsDatasetIdDeleteResponse422 & {
    headers: Headers;
  };

export type deleteDatasetApiDatasetsDatasetIdDeleteResponse =
  | deleteDatasetApiDatasetsDatasetIdDeleteResponseSuccess
  | deleteDatasetApiDatasetsDatasetIdDeleteResponseError;

export const getDeleteDatasetApiDatasetsDatasetIdDeleteUrl = (
  datasetId: string,
) => {
  return `/api/datasets/${datasetId}`;
};

/**
 * @summary Delete Dataset
 */
export const deleteDatasetApiDatasetsDatasetIdDelete = async (
  datasetId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<deleteDatasetApiDatasetsDatasetIdDeleteResponse> => {
  return orvalFetch<deleteDatasetApiDatasetsDatasetIdDeleteResponse>(
    getDeleteDatasetApiDatasetsDatasetIdDeleteUrl(datasetId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteDatasetApiDatasetsDatasetIdDeleteMutationKey = () =>
  ["deleteDatasetApiDatasetsDatasetIdDelete"] as const;

export const getDeleteDatasetApiDatasetsDatasetIdDeleteMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDatasetApiDatasetsDatasetIdDelete>>,
    TError,
    DeleteDatasetApiDatasetsDatasetIdDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDatasetApiDatasetsDatasetIdDelete>>,
  TError,
  DeleteDatasetApiDatasetsDatasetIdDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteDatasetApiDatasetsDatasetIdDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDatasetApiDatasetsDatasetIdDelete>>,
    DeleteDatasetApiDatasetsDatasetIdDeleteMutationVariables
  > = (props) => {
    const { datasetId } = props ?? {};

    return deleteDatasetApiDatasetsDatasetIdDelete(datasetId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDatasetApiDatasetsDatasetIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDatasetApiDatasetsDatasetIdDelete>>
>;

export type DeleteDatasetApiDatasetsDatasetIdDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type DeleteDatasetApiDatasetsDatasetIdDeleteMutationVariables = {
  datasetId: string;
};

/**
 * @summary Delete Dataset
 */
export const useDeleteDatasetApiDatasetsDatasetIdDelete = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDatasetApiDatasetsDatasetIdDelete>>,
      TError,
      DeleteDatasetApiDatasetsDatasetIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDatasetApiDatasetsDatasetIdDelete>>,
  TError,
  DeleteDatasetApiDatasetsDatasetIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteDatasetApiDatasetsDatasetIdDeleteMutationOptions(options),
    queryClient,
  );
};
export type listItemsApiDatasetsDatasetIdItemsGetResponse200 = {
  data: DatasetItemResponse[];
  status: 200;
};

export type listItemsApiDatasetsDatasetIdItemsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listItemsApiDatasetsDatasetIdItemsGetResponseSuccess =
  listItemsApiDatasetsDatasetIdItemsGetResponse200 & {
    headers: Headers;
  };
export type listItemsApiDatasetsDatasetIdItemsGetResponseError =
  listItemsApiDatasetsDatasetIdItemsGetResponse422 & {
    headers: Headers;
  };

export type listItemsApiDatasetsDatasetIdItemsGetResponse =
  | listItemsApiDatasetsDatasetIdItemsGetResponseSuccess
  | listItemsApiDatasetsDatasetIdItemsGetResponseError;

export const getListItemsApiDatasetsDatasetIdItemsGetUrl = (
  datasetId: string,
) => {
  return `/api/datasets/${datasetId}/items`;
};

/**
 * List trace IDs (and their pinned labels) in a dataset; the read is
 * recorded in the team's audit log (TRA-1626).
 * @summary List Items
 */
export const listItemsApiDatasetsDatasetIdItemsGet = async (
  datasetId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listItemsApiDatasetsDatasetIdItemsGetResponse> => {
  return orvalFetch<listItemsApiDatasetsDatasetIdItemsGetResponse>(
    getListItemsApiDatasetsDatasetIdItemsGetUrl(datasetId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListItemsApiDatasetsDatasetIdItemsGetQueryKey = (
  datasetId: string,
) => {
  return [`/api/datasets/${datasetId}/items`] as const;
};

export const getListItemsApiDatasetsDatasetIdItemsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListItemsApiDatasetsDatasetIdItemsGetQueryKey(datasetId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>
  > = ({ signal }) =>
    listItemsApiDatasetsDatasetIdItemsGet(datasetId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: datasetId !== null && datasetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListItemsApiDatasetsDatasetIdItemsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>
>;
export type ListItemsApiDatasetsDatasetIdItemsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListItemsApiDatasetsDatasetIdItemsGet<
  TData = Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
          TError,
          Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListItemsApiDatasetsDatasetIdItemsGet<
  TData = Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
          TError,
          Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListItemsApiDatasetsDatasetIdItemsGet<
  TData = Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Items
 */

export function useListItemsApiDatasetsDatasetIdItemsGet<
  TData = Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  datasetId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listItemsApiDatasetsDatasetIdItemsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListItemsApiDatasetsDatasetIdItemsGetQueryOptions(
    datasetId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type addItemApiDatasetsDatasetIdItemsPostResponse201 = {
  data: DatasetItemResponse;
  status: 201;
};

export type addItemApiDatasetsDatasetIdItemsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type addItemApiDatasetsDatasetIdItemsPostResponseSuccess =
  addItemApiDatasetsDatasetIdItemsPostResponse201 & {
    headers: Headers;
  };
export type addItemApiDatasetsDatasetIdItemsPostResponseError =
  addItemApiDatasetsDatasetIdItemsPostResponse422 & {
    headers: Headers;
  };

export type addItemApiDatasetsDatasetIdItemsPostResponse =
  | addItemApiDatasetsDatasetIdItemsPostResponseSuccess
  | addItemApiDatasetsDatasetIdItemsPostResponseError;

export const getAddItemApiDatasetsDatasetIdItemsPostUrl = (
  datasetId: string,
) => {
  return `/api/datasets/${datasetId}/items`;
};

/**
 * Add a trace to a dataset.
 *
 * Adding the same trace twice is a 409 — caller should remove first.
 * @summary Add Item
 */
export const addItemApiDatasetsDatasetIdItemsPost = async (
  datasetId: string,
  datasetItemAdd: DatasetItemAdd,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<addItemApiDatasetsDatasetIdItemsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<addItemApiDatasetsDatasetIdItemsPostResponse>(
    getAddItemApiDatasetsDatasetIdItemsPostUrl(datasetId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(datasetItemAdd),
    },
  );
};

export const getAddItemApiDatasetsDatasetIdItemsPostMutationKey = () =>
  ["addItemApiDatasetsDatasetIdItemsPost"] as const;

export const getAddItemApiDatasetsDatasetIdItemsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addItemApiDatasetsDatasetIdItemsPost>>,
    TError,
    AddItemApiDatasetsDatasetIdItemsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addItemApiDatasetsDatasetIdItemsPost>>,
  TError,
  AddItemApiDatasetsDatasetIdItemsPostMutationVariables,
  TContext
> => {
  const mutationKey = getAddItemApiDatasetsDatasetIdItemsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addItemApiDatasetsDatasetIdItemsPost>>,
    AddItemApiDatasetsDatasetIdItemsPostMutationVariables
  > = (props) => {
    const { datasetId, data } = props ?? {};

    return addItemApiDatasetsDatasetIdItemsPost(
      datasetId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddItemApiDatasetsDatasetIdItemsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof addItemApiDatasetsDatasetIdItemsPost>>
>;
export type AddItemApiDatasetsDatasetIdItemsPostMutationBody = DatasetItemAdd;
export type AddItemApiDatasetsDatasetIdItemsPostMutationError =
  ErrorType<HTTPValidationError>;
export type AddItemApiDatasetsDatasetIdItemsPostMutationVariables = {
  datasetId: string;
  data: DatasetItemAdd;
};

/**
 * @summary Add Item
 */
export const useAddItemApiDatasetsDatasetIdItemsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addItemApiDatasetsDatasetIdItemsPost>>,
      TError,
      AddItemApiDatasetsDatasetIdItemsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addItemApiDatasetsDatasetIdItemsPost>>,
  TError,
  AddItemApiDatasetsDatasetIdItemsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getAddItemApiDatasetsDatasetIdItemsPostMutationOptions(options),
    queryClient,
  );
};
export type removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponse200 = {
  data: RemoveItemApiDatasetsDatasetIdItemsTraceIdDelete200;
  status: 200;
};

export type removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponseSuccess =
  removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponse200 & {
    headers: Headers;
  };
export type removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponseError =
  removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponse422 & {
    headers: Headers;
  };

export type removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponse =
  | removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponseSuccess
  | removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponseError;

export const getRemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteUrl = (
  datasetId: string,
  traceId: string,
) => {
  return `/api/datasets/${datasetId}/items/${traceId}`;
};

/**
 * Remove a trace from a dataset by trace_id.
 * @summary Remove Item
 */
export const removeItemApiDatasetsDatasetIdItemsTraceIdDelete = async (
  datasetId: string,
  traceId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponse> => {
  return orvalFetch<removeItemApiDatasetsDatasetIdItemsTraceIdDeleteResponse>(
    getRemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteUrl(datasetId, traceId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationKey =
  () => ["removeItemApiDatasetsDatasetIdItemsTraceIdDelete"] as const;

export const getRemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeItemApiDatasetsDatasetIdItemsTraceIdDelete>
      >,
      TError,
      RemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof removeItemApiDatasetsDatasetIdItemsTraceIdDelete>
    >,
    TError,
    RemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getRemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof removeItemApiDatasetsDatasetIdItemsTraceIdDelete>
      >,
      RemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationVariables
    > = (props) => {
      const { datasetId, traceId } = props ?? {};

      return removeItemApiDatasetsDatasetIdItemsTraceIdDelete(
        datasetId,
        traceId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeItemApiDatasetsDatasetIdItemsTraceIdDelete>>
  >;

export type RemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationError =
  ErrorType<HTTPValidationError>;
export type RemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationVariables =
  { datasetId: string; traceId: string };

/**
 * @summary Remove Item
 */
export const useRemoveItemApiDatasetsDatasetIdItemsTraceIdDelete = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof removeItemApiDatasetsDatasetIdItemsTraceIdDelete>
      >,
      TError,
      RemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeItemApiDatasetsDatasetIdItemsTraceIdDelete>>,
  TError,
  RemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getRemoveItemApiDatasetsDatasetIdItemsTraceIdDeleteMutationOptions(options),
    queryClient,
  );
};
